import ProcessorKeyBased from './ProcessorKeyBased';
import ProcessorOAuthCredentials from './ProcessorOAuthCredentials';
import ProcessorShopify from './ProcessorShopify';

export function buildProcessorSettings(processorId, state) {
    const entry = REGISTRY[processorId] || REGISTRY.default;
    return entry.buildSettings(state);
}

export function applyProcessorLoadedSettings(processorId, settings, setProcessorSettings) {
    const entry = REGISTRY[processorId] || REGISTRY.default;
    entry.applyLoadedSettings(settings, setProcessorSettings);
}

export function getProcessorCreateUrlSuffix(processorId, action) {
    const entry = REGISTRY[processorId] || REGISTRY.default;
    const useTest = action === 'continue' && !entry.skipTestForCreate;
    return useTest ? ['test', processorId] : [processorId];
}

export function getProcessorComponent(processorId) {
    const entry = REGISTRY[processorId];
    if (entry != null && 'Component' in entry) {
        return entry.Component;
    }
    return REGISTRY.default.Component;
}

export function processorShowDeliveredStatus(processorId) {
    return (REGISTRY[processorId] || REGISTRY.default).showDeliveredStatus ?? false;
}

export function processorShowCountOfPackages(processorId) {
    return (REGISTRY[processorId] || REGISTRY.default).showCountOfPackages ?? false;
}

export function processorShowExportStatus(processorId) {
    return (REGISTRY[processorId] || REGISTRY.default).showExportStatus !== false;
}

export function processorShowUrlField(processorId) {
    return (REGISTRY[processorId] || REGISTRY.default).showUrlField !== false;
}

export function processorShowCarrierType(processorId) {
    return (REGISTRY[processorId] || REGISTRY.default).showCarrierType === true;
}

export function processorShowDownloadError(processorId, type) {
    const typeKeyMap = {
        'status': 'showStatusDownloadError',
        'shippers': 'showShippersDownloadError',
        'paymentMethods': 'showPaymentMethodsDownloadError',
    };
    const entry = REGISTRY[processorId] || REGISTRY.default;
    const key = typeKeyMap[type];
    return entry[key] !== false;
}

export function getProcessorEntry(processorId) {
    return REGISTRY[processorId] || REGISTRY.default;
}

const REGISTRY = {
    shoptet: {
        Component: ProcessorKeyBased,
        buildSettings: (s) => ({ key: s.key }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({ ...prev, key: settings.key ?? '' }));
        },
        showDeliveredStatus: true,
        showCountOfPackages: false,
        skipTestForCreate: true,
        keyDisabled: true,
    },
    prestashop: {
        Component: ProcessorKeyBased,
        buildSettings: (s) => ({ key: s.key }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({ ...prev, key: settings.key ?? '' }));
        },
        showDeliveredStatus: false,
        showCountOfPackages: false,
        skipTestForCreate: false,
        keyDisabled: false,
    },
    money: {
        Component: ProcessorOAuthCredentials,
        buildSettings: (s) => ({
            clientId: s.clientId,
            clientSecret: s.clientSecret,
            connectorCountOfPackages: s.connectorCountOfPackages,
        }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({
                ...prev,
                clientId: settings.clientId ?? '',
                clientSecret: settings.clientSecret ?? '',
                connectorCountOfPackages: settings.connectorCountOfPackages ?? '',
            }));
        },
        showDeliveredStatus: false,
        showCountOfPackages: true,
        skipTestForCreate: true,
    },
    woocommerce: {
        Component: ProcessorOAuthCredentials,
        buildSettings: (s) => ({
            clientId: s.clientId,
            clientSecret: s.clientSecret,
            key: undefined,
        }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({
                ...prev,
                clientId: settings.clientId ?? '',
                clientSecret: settings.clientSecret ?? '',
            }));
        },
        showDeliveredStatus: false,
        showCountOfPackages: false,
        skipTestForCreate: false,
    },
    shopify: {
        Component: ProcessorShopify,
        showUrlField: false,
        showCarrierType: true,
        buildSettings: (s) => ({
            shopId: s.shopId,
            shopPass: s.shopPass,
        }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({
                ...prev,
                shopId: settings.shopId ?? '',
                shopPass: settings.shopPass ?? '',
            }));
        },
        showDeliveredStatus: false,
        showCountOfPackages: false,
        showExportStatus: false,
        showStatusDownloadError: false,
        showShippersDownloadError: false,
        showPaymentMethodsDownloadError: false,
        skipTestForCreate: false,
        keyDisabled: false,
    },
    default: {
        Component: ProcessorKeyBased,
        buildSettings: (s) => ({ key: s.key }),
        applyLoadedSettings: (settings, setProcessorSettings) => {
            setProcessorSettings(prev => ({ ...prev, key: settings.key ?? '' }));
        },
        showDeliveredStatus: false,
        showCountOfPackages: false,
        showExportStatus: true,
        showStatusDownloadError: true,
        showShippersDownloadError: true,
        showPaymentMethodsDownloadError: true,
        skipTestForCreate: false,
        keyDisabled: false,
    },
};
